module.exports = __webpack_public_path__ + "img/dingwei@3x.1a2c21f4.svg";